import { render, staticRenderFns } from "./UpdateHoursMaintenanceComponent.vue?vue&type=template&id=5e054805&scoped=true"
import script from "./UpdateHoursMaintenanceComponent.vue?vue&type=script&lang=js"
export * from "./UpdateHoursMaintenanceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e054805",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e054805')) {
      api.createRecord('5e054805', component.options)
    } else {
      api.reload('5e054805', component.options)
    }
    module.hot.accept("./UpdateHoursMaintenanceComponent.vue?vue&type=template&id=5e054805&scoped=true", function () {
      api.rerender('5e054805', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/somos1/UpdateHoursMaintenanceComponent.vue"
export default component.exports